import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=cb62dd0c&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb62dd0c')) {
      api.createRecord('cb62dd0c', component.options)
    } else {
      api.reload('cb62dd0c', component.options)
    }
    module.hot.accept("./agreement.vue?vue&type=template&id=cb62dd0c&", function () {
      api.rerender('cb62dd0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/model/agreement.vue"
export default component.exports